import type { NextPage } from 'next';

import { createClient } from '../../prismicio';

import Footer from '@components/Footer';
import FaqsPage from '@containers/Faqs';
import Head from 'next/head';

const Faqs: NextPage = ({ page }: any) => {
  const { seo_title, slices } = page?.data || {};

  return (
    <>
      <Head>
        <title>FAQs and Help | The Cumin Club</title>
      </Head>
      <FaqsPage slices={slices} />
      <Footer />
    </>
  );
};
export default Faqs;

export async function getStaticProps() {
  const client = createClient();
  const page = await client.getByUID('faq_page', 'faq_page');

  return {
    props: {
      page,
    },
  };
}
